import React from 'react';
import { noop } from 'lodash-es';

export const LoadingCoordinatorContext = React.createContext({
  isFullyLoaded: false,
  setLoadingStatus: noop,
  loadableComponents: {},
});
